import React from "react";
import ReactTooltip from "react-tooltip";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { func } from "prop-types";
import { monitoringQueueEntryType } from "../../../../../../../prop-types/monitoringQueueEntryTypes";
import routesConfig from "../../../../../../../routes/routes-config";
import { getRiskColor } from "../../../../../../../utilities/riskColor";
import { DocumentIcon, PdfIcon } from "../../../../../../../assets";

const SingleClientReportEntriesTableRow = ({
  entry,
  handleExportPdf,
  organizationInfo,
  loading,
}) => {
  function getCustomParameterByType(type) {
    let parameterValue = "";
    try {
      if (!entry.clientParams) {
        return parameterValue;
      }

      const theValue = entry.clientParams.find(
        (param) => param["name"] === type
      );

      if (theValue) {
        parameterValue = theValue.value;
      }
    } catch (error) {
      console.error("Something went wrong with customClientParameters");
    }

    return parameterValue;
  }
  return (
    <React.Fragment>
      <tr>
        <td>{entry.type}</td>
        <td width={300}>
          {entry.clientParams.find((sp) => sp.name === "Client").value}
        </td>
        <td>{entry.clientParams.find((sp) => sp.name === "EGN_UCN").value}</td>
        <td>{entry.offerId}</td>
        <td>{entry.isActive ? "Active" : "Inactive"}</td>
        <td
          style={
            entry.riskClass
              ? { color: getRiskColor({ key: entry.riskClass }) }
              : {}
          }
        >
          {entry.riskClass}
        </td>
        {organizationInfo &&
          organizationInfo.additionalOrganizationProperties &&
          organizationInfo.additionalOrganizationProperties.map((element) => {
            return <td>{getCustomParameterByType(element.name)}</td>;
          })}
        <td className="d-flex align-items-center">
          <Link
            to={routesConfig.singleClientReportDetails.path.replace(
              ":id",
              entry.id
            )}
            data-tip
            data-for="report-icon"
            target="_blank"
            style={{ height: 20 }}
            className="icon"
          >
            <DocumentIcon />
          </Link>
          <ReactTooltip id="report-icon" type="info" effect="solid">
            <span>Generate Report</span>
          </ReactTooltip>

          <Button
            data-tip
            data-for="pdf-icon"
            color="link"
            className="p-0 m-0"
            onClick={() => handleExportPdf(entry.id)}
            disabled={loading === entry.id}
          >
            <ReactTooltip id="pdf-icon" type="info" effect="solid">
              <span>Export to PDF</span>
            </ReactTooltip>
            <PdfIcon />
          </Button>
          {/* <a href={exportPdfPath} target="_blank" rel="noopener noreferrer" className="icon">
            <ReactTooltip id="pdf-icon" type="info">
              <span>Export to PDF</span>
            </ReactTooltip>
            <FaFilePdf
              size="1.3em"
              data-tip
              data-for="pdf-icon"
              color="cornflowerblue"
            />
          </a> */}
        </td>
      </tr>
    </React.Fragment>
  );
};

SingleClientReportEntriesTableRow.propTypes = {
  entry: monitoringQueueEntryType,
  handleExportPdf: func.isRequired,
};

export default SingleClientReportEntriesTableRow;



// WEBPACK FOOTER //
// ./src/features/reports/components/single-client/form/table/row/SingleClientReportEntriesTableRow.jsx